"use strict";
const $a5fd07fa01589658$var$gameStatus = {
    IDLE: "idle",
    PLAYING: "playing",
    WIN: "win",
    LOSE: "lose"
};
const $a5fd07fa01589658$var$defIniState = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState){
        this.initialState = initialState || $a5fd07fa01589658$var$defIniState;
        this.state = this.initialState.map((row)=>[
                ...row
            ]);
        this.score = 0;
        this.status = $a5fd07fa01589658$var$gameStatus.IDLE;
        this.lastMoves = [];
    }
    selectRandomField() {
        const emptyCells = [];
        for(let x = 0; x < 4; x++){
            for(let y = 0; y < 4; y++)if (this.state[x][y] === 0) emptyCells.push({
                x: x,
                y: y
            });
        }
        if (emptyCells.length === 0) return null;
        const randomIndex = Math.floor(Math.random() * emptyCells.length);
        return emptyCells[randomIndex];
    }
    addRandom() {
        const cell = this.selectRandomField();
        if (cell === null) return;
        const val = Math.random() < 0.1 ? 4 : 2;
        this.state[cell.x][cell.y] = val;
    }
    processLine(array) {
        const filtered = array.map((val, idx)=>({
                val: val,
                origIdx: idx
            })).filter((el)=>el.val !== 0);
        const res = [];
        const moves = [];
        let i = 0;
        let resultIdx = 0;
        while(i < filtered.length){
            if (i < filtered.length - 1 && filtered[i].val === filtered[i + 1].val) {
                res.push(filtered[i].val * 2);
                this.score += filtered[i].val * 2;
                moves.push({
                    from: filtered[i].origIdx,
                    to: resultIdx,
                    merged: false
                });
                moves.push({
                    from: filtered[i + 1].origIdx,
                    to: resultIdx,
                    merged: true
                });
                i += 2;
            } else {
                res.push(filtered[i].val);
                moves.push({
                    from: filtered[i].origIdx,
                    to: resultIdx,
                    merged: false
                });
                i += 1;
            }
            resultIdx++;
        }
        while(res.length < 4)res.push(0);
        return {
            result: res,
            moves: moves
        };
    }
    moveLeft() {
        if (this.status !== $a5fd07fa01589658$var$gameStatus.PLAYING) return;
        this.lastMoves = [];
        const newState = [];
        for(let row = 0; row < 4; row++){
            const { result: result, moves: moves } = this.processLine(this.state[row]);
            newState.push(result);
            moves.forEach((move)=>{
                this.lastMoves.push({
                    fromRow: row,
                    fromCol: move.from,
                    toRow: row,
                    toCol: move.to,
                    merged: move.merged
                });
            });
        }
        this.state = newState;
    }
    moveRight() {
        if (this.status !== $a5fd07fa01589658$var$gameStatus.PLAYING) return;
        this.lastMoves = [];
        const newState = [];
        for(let row = 0; row < 4; row++){
            const reversed = [
                ...this.state[row]
            ].reverse();
            const { result: result, moves: moves } = this.processLine(reversed);
            newState.push(result.reverse());
            moves.forEach((move)=>{
                this.lastMoves.push({
                    fromRow: row,
                    fromCol: 3 - move.from,
                    toRow: row,
                    toCol: 3 - move.to,
                    merged: move.merged
                });
            });
        }
        this.state = newState;
    }
    moveUp() {
        if (this.status !== $a5fd07fa01589658$var$gameStatus.PLAYING) return;
        this.lastMoves = [];
        const newState = [
            [],
            [],
            [],
            []
        ];
        for(let col = 0; col < 4; col++){
            const column = [
                this.state[0][col],
                this.state[1][col],
                this.state[2][col],
                this.state[3][col]
            ];
            const { result: result, moves: moves } = this.processLine(column);
            for(let row = 0; row < 4; row++)newState[row][col] = result[row];
            moves.forEach((move)=>{
                this.lastMoves.push({
                    fromRow: move.from,
                    fromCol: col,
                    toRow: move.to,
                    toCol: col,
                    merged: move.merged
                });
            });
        }
        this.state = newState;
    }
    moveDown() {
        if (this.status !== $a5fd07fa01589658$var$gameStatus.PLAYING) return;
        this.lastMoves = [];
        const newState = [
            [],
            [],
            [],
            []
        ];
        for(let col = 0; col < 4; col++){
            const column = [
                this.state[0][col],
                this.state[1][col],
                this.state[2][col],
                this.state[3][col]
            ];
            const reversed = [
                ...column
            ].reverse();
            const { result: result, moves: moves } = this.processLine(reversed);
            const finalResult = result.reverse();
            for(let row = 0; row < 4; row++)newState[row][col] = finalResult[row];
            moves.forEach((move)=>{
                this.lastMoves.push({
                    fromRow: 3 - move.from,
                    fromCol: col,
                    toRow: 3 - move.to,
                    toCol: col,
                    merged: move.merged
                });
            });
        }
        this.state = newState;
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.state;
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    checkWin() {
        const win = this.state.some((el)=>el.some((sub)=>sub === 2048));
        if (win) {
            this.status = $a5fd07fa01589658$var$gameStatus.WIN;
            return true;
        }
        return false;
    }
    checkLose() {
        if (this.state.some((el)=>el.some((sub)=>sub === 0))) return false;
        for(let row = 0; row < 4; row++)for(let col = 0; col < 4; col++){
            const current = this.state[row][col];
            if (col < 3 && this.state[row][col + 1] === current) return false;
            if (row < 3 && this.state[row + 1][col] === current) return false;
        }
        this.status = $a5fd07fa01589658$var$gameStatus.LOSE;
        return true;
    }
    /**
   * Starts the game.
   */ start() {
        this.state = this.initialState.map((row)=>[
                ...row
            ]);
        this.status = $a5fd07fa01589658$var$gameStatus.PLAYING;
        this.addRandom();
        this.addRandom();
    }
    /**
   * Resets the game.
   */ restart() {
        this.state = this.initialState.map((row)=>[
                ...row
            ]);
        this.score = 0;
        this.status = $a5fd07fa01589658$var$gameStatus.IDLE;
    }
}
var $a5fd07fa01589658$export$2e2bcd8739ae039 = $a5fd07fa01589658$var$Game;


"use strict";
// Uncomment the next lines to use your game instance in the browser
const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
// Write your code here
const $09e991522ca7e64e$var$cells = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startButton = document.querySelector(".start");
const $09e991522ca7e64e$var$startMessage = document.querySelector(".message-start");
const $09e991522ca7e64e$var$winMessage = document.querySelector(".message-win");
const $09e991522ca7e64e$var$loseMessage = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$gameField = document.querySelector(".game-field");
// Wrap game field in a relative container for the tile overlay
const $09e991522ca7e64e$var$wrapper = document.createElement("div");
$09e991522ca7e64e$var$wrapper.className = "game-field-wrapper";
$09e991522ca7e64e$var$gameField.parentNode.insertBefore($09e991522ca7e64e$var$wrapper, $09e991522ca7e64e$var$gameField);
$09e991522ca7e64e$var$wrapper.appendChild($09e991522ca7e64e$var$gameField);
const $09e991522ca7e64e$var$overlay = document.createElement("div");
$09e991522ca7e64e$var$overlay.className = "tile-overlay";
$09e991522ca7e64e$var$wrapper.appendChild($09e991522ca7e64e$var$overlay);
const $09e991522ca7e64e$var$CELL_SIZE = 75;
const $09e991522ca7e64e$var$CELL_GAP = 10;
const $09e991522ca7e64e$var$ANIM_MS = 120;
function $09e991522ca7e64e$var$tileXY(row, col) {
    return {
        x: $09e991522ca7e64e$var$CELL_GAP + col * ($09e991522ca7e64e$var$CELL_SIZE + $09e991522ca7e64e$var$CELL_GAP),
        y: $09e991522ca7e64e$var$CELL_GAP + row * ($09e991522ca7e64e$var$CELL_SIZE + $09e991522ca7e64e$var$CELL_GAP)
    };
}
function $09e991522ca7e64e$var$createTileEl(value, row, col) {
    const pos = document.createElement("div");
    pos.className = "tile-pos";
    const { x: x, y: y } = $09e991522ca7e64e$var$tileXY(row, col);
    pos.style.transform = `translate(${x}px, ${y}px)`;
    const tile = document.createElement("div");
    tile.className = `tile tile--${value}`;
    tile.textContent = value;
    pos.appendChild(tile);
    $09e991522ca7e64e$var$overlay.appendChild(pos);
    return pos;
}
function $09e991522ca7e64e$var$renderTiles(state, mergedSet = new Set(), newRow = -1, newCol = -1) {
    $09e991522ca7e64e$var$overlay.innerHTML = "";
    for(let row = 0; row < 4; row++){
        for(let col = 0; col < 4; col++)if (state[row][col] !== 0) {
            const pos = $09e991522ca7e64e$var$createTileEl(state[row][col], row, col);
            const tile = pos.querySelector(".tile");
            if (row === newRow && col === newCol) tile.classList.add("tile--appear");
            else if (mergedSet.has(`${row},${col}`)) tile.classList.add("tile--merge");
        }
    }
}
function $09e991522ca7e64e$var$render() {
    $09e991522ca7e64e$var$cells.forEach((cell)=>{
        cell.className = "field-cell";
        cell.textContent = "";
    });
    $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$renderTiles($09e991522ca7e64e$var$game.getState());
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.status === "win") $09e991522ca7e64e$var$winMessage.classList.add("hidden");
    if ($09e991522ca7e64e$var$game.status === "lose") $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
    if (!$09e991522ca7e64e$var$startMessage.classList.contains("hidden")) $09e991522ca7e64e$var$startMessage.classList.add("hidden");
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$startButton.innerHTML = "Restart";
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
    } else $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$render();
});
let $09e991522ca7e64e$var$isAnimating = false;
window.addEventListener("keydown", async (e)=>{
    if ($09e991522ca7e64e$var$isAnimating || $09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    const snap = $09e991522ca7e64e$var$game.getState().map((row)=>[
            ...row
        ]);
    switch(e.key){
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        default:
            return;
    }
    let changed = false;
    for(let i = 0; i < 4 && !changed; i++){
        for(let x = 0; x < 4; x++)if (snap[i][x] !== $09e991522ca7e64e$var$game.state[i][x]) {
            changed = true;
            break;
        }
    }
    if (!changed) return;
    $09e991522ca7e64e$var$isAnimating = true;
    // Build tile elements at old positions, no transition yet
    $09e991522ca7e64e$var$overlay.innerHTML = "";
    const tileMap = new Map();
    for(let row = 0; row < 4; row++){
        for(let col = 0; col < 4; col++)if (snap[row][col] !== 0) {
            const pos = $09e991522ca7e64e$var$createTileEl(snap[row][col], row, col);
            pos.style.transition = "none";
            tileMap.set(`${row},${col}`, pos);
        }
    }
    // Force reflow so transition: none takes effect
    $09e991522ca7e64e$var$overlay.getBoundingClientRect();
    // Slide tiles to new positions
    const moves = $09e991522ca7e64e$var$game.lastMoves;
    for (const move of moves){
        const pos = tileMap.get(`${move.fromRow},${move.fromCol}`);
        if (pos) {
            const { x: x, y: y } = $09e991522ca7e64e$var$tileXY(move.toRow, move.toCol);
            pos.style.transition = `transform ${$09e991522ca7e64e$var$ANIM_MS}ms ease`;
            pos.style.transform = `translate(${x}px, ${y}px)`;
        }
    }
    await new Promise((resolve)=>setTimeout(resolve, $09e991522ca7e64e$var$ANIM_MS));
    // Add random tile and find its position
    const stateBeforeRandom = $09e991522ca7e64e$var$game.getState().map((row)=>[
            ...row
        ]);
    $09e991522ca7e64e$var$game.addRandom();
    const newState = $09e991522ca7e64e$var$game.getState();
    let newRow = -1;
    let newCol = -1;
    outer: for(let row = 0; row < 4; row++){
        for(let col = 0; col < 4; col++)if (stateBeforeRandom[row][col] === 0 && newState[row][col] !== 0) {
            newRow = row;
            newCol = col;
            break outer;
        }
    }
    const mergedSet = new Set(moves.filter((m)=>m.merged).map((m)=>`${m.toRow},${m.toCol}`));
    $09e991522ca7e64e$var$renderTiles(newState, mergedSet, newRow, newCol);
    $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$isAnimating = false;
    if ($09e991522ca7e64e$var$game.checkWin()) $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
    if ($09e991522ca7e64e$var$game.checkLose()) $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
});


//# sourceMappingURL=index.c0c38935.js.map
